import Swiper from 'swiper/bundle';
import { accessiblePagination, bindPaginationButtons } from '../lib/swiper-pagination.js';
import { onReady } from '../lib/on-ready.js';

function initStandardCarousels() {
    document.querySelectorAll('.swiper-container.swiper-standard-carousel').forEach((container) => {
        if (container.swiper) {
            return;
        }

        new Swiper(container, {
            effect: 'coverflow',
            grabCursor: true,
            centeredSlides: true,
            slidesPerView: 'auto',
            loop: false,
            navigation: {
                nextEl: container.querySelector('.swiper-button-next.sc-swiper-button-next'),
                prevEl: container.querySelector('.swiper-button-prev.sc-swiper-button-prev'),
            },
            pagination: {
                el: container.querySelector('.swiper-pagination'),
                ...accessiblePagination,
            },
            coverflowEffect: {
                rotate: 42,
                stretch: 0,
                depth: 180,
                modifier: 1.15,
                slideShadows: true,
            },
            a11y: {
                enabled: true,
                slideLabelMessage: 'Slide {{index}} of {{slidesLength}}',
            },
            on: {
                init(swiper) {
                    bindPaginationButtons(swiper);
                },
                slideChange(swiper) {
                    bindPaginationButtons(swiper);
                },
                paginationUpdate(swiper) {
                    bindPaginationButtons(swiper);
                },
            },
        });
    });
}

onReady(initStandardCarousels);
